import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  bookMarks: [{}] as IProfile[],
  Tabs: '',
}

const exploreSlice = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    setBookMark: (state, action) => {
      state.bookMarks = action.payload
    },
    setTabs: (state, action) => {
      state.Tabs = action.payload
    },
  },
  extraReducers: () => {},
})

export const exploreActions = exploreSlice.actions
const exploreReducer = exploreSlice.reducer
export default exploreReducer
